"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 20 20'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.31015625,10 C4.31015625,9.35046875 4.41796875,8.72765625 4.610625,8.14359375 L1.2403125,5.57 C0.5834375,6.90359375 0.2134375,8.40640625 0.2134375,10 C0.2134375,11.5923437 0.583125,13.0940625 1.23890625,14.426875 L4.60734375,11.8482812 C4.4165625,11.266875 4.31015625,10.6464062 4.31015625,10",
    fill: "#FBBC05"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.2276562,4.0909375 C11.63875,4.0909375 12.9132812,4.5909375 13.9146875,5.4090625 L16.8278125,2.5 C15.0526563,0.95453125 12.7767188,0 10.2276562,0 C6.27015625,0 2.86890625,2.263125 1.2403125,5.57 L4.61046875,8.14359375 C5.38703125,5.78640625 7.600625,4.0909375 10.2276562,4.0909375",
    fill: "#EA4335"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.2276562,15.9090625 C7.60078125,15.9090625 5.3871875,14.2135937 4.610625,11.8564062 L1.2403125,14.4295313 C2.86890625,17.736875 6.27015625,20 10.2276562,20 C12.6701562,20 15.0021875,19.1326563 16.7523438,17.5076563 L13.5532812,15.0345313 C12.650625,15.603125 11.5139062,15.9090625 10.2276562,15.9090625",
    fill: "#34A853"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.7865625,10 C19.7865625,9.4090625 19.6954688,8.77265625 19.5589062,8.181875 L10.2276563,8.181875 L10.2276563,12.0454688 L15.5989063,12.0454688 C15.3303125,13.3628125 14.599375,14.3754688 13.5532813,15.0345313 L16.7523438,17.5076563 C18.5907812,15.8014062 19.7865625,13.2595313 19.7865625,10",
    fill: "#4285F4"
  }));
});